import React from 'react';
import {Stack} from '@mui/material';

import {AlertInfo} from 'presentation/components/AlertInfo';
import {ErrorAlertProps} from './types';

const ErrorAlert = ({message}: ErrorAlertProps) => (
	<Stack>
		<AlertInfo.Root severity="error">
			<AlertInfo.Title sx={{fontWeight: 600, mb: 0}} title={message} />
		</AlertInfo.Root>
	</Stack>
);

export {ErrorAlert};
